<template>
    <div>
        <Title :strong="2">评论区（共{{ total }}条评论）</Title>
        <div v-show="hasLogin" class="writeboard">
            <div class="help">
                <a-button type="link" @click="() => showHelp = !showHelp">
                    复杂评论预览<a-icon :type="showHelp ? 'caret-up' : 'caret-down'" />
                </a-button>
                <comment-preview v-show="showHelp" :text="text" />
            </div>
            <a-textarea v-model="text" ref="writeboard" auto-size></a-textarea>
            <div class="optbar">
                <a-button :loading="posting" @click="submit" type="primary">我也说一句</a-button>
            </div>
        </div>
        <a-result v-show="!hasLogin" title="尚未登录，请登录后回复">
            <template #icon></template>
            <template #extra>
            <a-button type="primary">
                <a href="/user/login.html?from">登录</a>
            </a-button>
            </template>
        </a-result>
        <a-list
            class="comment-list"
            item-layout="horizontal"
            :data-source="comments"
        >
            <a-list-item slot="renderItem" slot-scope="comment" :id="`p${ comment.id }`">
                <Comment :comment="comment" @edit="openEditDialog"></Comment>
            </a-list-item>
        </a-list>
        <a-modal
            :title="`编辑评论 - #${editComment.id}`"
            :visible="editorVisible"
            :confirm-loading="editing"
            @ok="doEdit"
            @cancel="() => editorVisible = false"
            :okCancel="false"
            width="95%" :maskClosable="false"
        >
            <comment-preview :text="editData" />
            <a-textarea v-model="editData" ref="writeboard" auto-size></a-textarea>
        </a-modal>
    </div>
</template>

<script>
import Title from '@/components/Title.vue';
import Comment from '../components/Comment.vue';
import { mapState } from 'vuex';
import { createFormData, getReason, parseText } from '../../../utils/utils';
import axios from 'axios';
import CommentPreview from '../components/CommentPreview.vue';

export default {
    props: {
        comments: Array,
    },
    data: () => ({
        text: '',
        posting: false,
        showHelp: false,

        editorVisible: false,
        editData: '',
        editComment: {},
        editing: false,
    }),
    inject: [ 'app' ],
    provide() {
        return {
            commentBoard: this,
        }
    },
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
        total() {
            return this.comments.reduce((sum, e) => {
                return sum + e.replies.length + 1;
            }, 0)
        }
    },
    methods: {
        parseText,
        openEditDialog(comment) {
            this.editComment = comment;
            this.editData = comment.comment;
            this.editorVisible = true;
        },
        async doEdit() {
            this.editing = true;
            const { data } = await axios.post("/backend/tower/discussion/editComment.php", createFormData({
                id: this.editComment.id,
                content: this.editData,
            }));
            this.editing = false;
            if (data.code == 0) {
                this.editorVisible = false;
                this.$message.success('修改成功');
                window.location.reload();
            } else {
                const reason = getReason(data.code, {
                    '-2': '字数超限',
                });
                this.$message.error(`修改失败 ${ reason }`);
            }
        },
        async submit() {
            const { text: content } = this;
            const { tower: { name } } = this.app;
            this.posting = true;
            await this.appendComment({ name, content });
            this.posting = false;
        },
        async appendComment({ name, content }) {
            try {
                const { data } = await axios
                    .post("/backend/tower/discussion/appendComment.php", createFormData({
                        name, content
                    }));
                if (data.code == 0) {
                    this.$message.success('回复成功');
                    window.location.reload();
                } else {
                    const reason = getReason(data.code);
                    this.$message.error(`回复失败: ${ reason }`);
                }
            } catch (e) {
                this.$message.error(`回复失败, 错误: ${ e }`);
            }
        },
        async appendSubcomment({ pid, content, replyto }) {
            try {
                const { data } = await axios
                    .post("/backend/tower/discussion/appendSubcomment.php", createFormData({
                        pid, content, replyto
                    }));
                if (data.code == 0) {
                    this.$message.success('回复成功');
                    const comment = this.comments.find(e => e.id === pid);
                    comment.replies = data.subcomments;
                } else {
                    const reason = getReason(data.code);
                    this.$message.error(`回复失败: ${ reason }`);
                }
            } catch (e) {
                this.$message.error(`回复失败, 错误: ${ e }`);
            }
        },
        async deleteComment(id) {
            this.$confirm({
                title: '确认要删除评论吗？',
                content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                onOk: async() => {
                    const { data } = await axios
                        .post("/backend/tower/discussion/deleteComment.php", createFormData({
                            id
                        }));
                    if (data.code == 0) {
                        this.$message.success('删除成功');
                        window.location.reload();
                    } else {
                        this.$message.error('删除失败');
                    }
                },
                onCancel() {
                    //
                },
            });
        },
        async deleteCommentByAdmin(id) {
            const reason = prompt('确认要删除回帖吗？\n你正在动用管理权限，请给出删除理由', '');
            if (reason === null) return;
            const { data } = await axios
                .post("/backend/tower/discussion/deleteComment.php", createFormData({
                    id, reason
                }));
            if (data.code == 0) {
                this.$message.success('删除成功');
                window.location.reload();
            } else {
                this.$message.error('删除失败');
            }
        },
        async manageComment({ id, key, value }) {
            const { data } = await axios
                .post("/backend/tower/discussion/manageComment.php", createFormData({
                    id, key, value,
                }));
            if (data.code == 0) {
                this.$message.success('修改成功');
                window.location.reload();
            } else {
                this.$message.error('修改失败');
                //
            }
        },
    },
    components: {
        Comment,
        Title,
        CommentPreview,
    },
}
</script>

<style lang="less" scoped>
.comment-list {
    margin: 0 5px;
}
.writeboard {
    margin: 10px;
}
.optbar {
    margin: 10px;
    text-align: right;
}
.help {
    text-align: left;
}
</style>
